import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { allFilterPages } from '@features/filter/static/filterUtil';
import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

import { fetchEnumValues } from '@services/commonService';

const FabricType = ({ filterPageName, isDependentFilter }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setData(allData);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.SUPPLIER_LIST]: dependentFilterList?.supplierCategoryList,
		[allFilterPages.SAMPLE_LIST]: dependentFilterList?.fabricTypeList,
		[allFilterPages.SAMPLE_DETAILS]: dependentFilterList?.fabricTypeList,
		[allFilterPages.COSTING_LIST]: dependentFilterList?.fabricTypeList,
		[allFilterPages.COSTING_DETAILS]: dependentFilterList?.fabricTypeList
	};

	const onFetchData = async () => {
		let responseData = isDependentFilter
			? filterData[filterPageName]
			: await fetchEnumValues('info.nitex.app.materials.FabricType');
		responseData = responseData?.map((item) => {
			return { id: item.constant, name: item.name, count: item?.count };
		});
		setAllData(responseData);
		setData(responseData);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allData?.filter((item) => item?.name?.toLowerCase().includes(e.target.value.toLowerCase()))
			: allData;
		setData(searchResult);
	};
	return (
		<>
			<FilterName type="FABRIC_TYPE" />
			<Checkbox data={data} type="FABRIC_TYPE" handleSearch={handleSearch} />
		</>
	);
};

export default FabricType;
